'use client';

import { Popover, Transition } from '@headlessui/react';
import { Button } from 'components';
import { BinIcon, DotsIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { Fragment, useState } from 'react';
import ModalDeleteAccount from './ModalDeleteAccount';

const RemoveAccount = () => {
  const t = useTranslations();

  const [modalDeleteAccountOpen, setModalDeleteAccountOpen] = useState(false);

  const handleOpenDelete = () => setModalDeleteAccountOpen(true);
  const handleCloseDelete = () => setModalDeleteAccountOpen(false);

  return (
    <>
      <Popover className="relative flex items-center justify-center">
        <Popover.Button as="div" className="outline-none">
          <DotsIcon className="cursor-pointer" />
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <Popover.Panel className="absolute bottom-[2rem] left-[-34px] z-10 -translate-x-1/2 px-2 sm:px-0">
            <div className="overflow-hidden rounded-3xl border border-tertiary-400 bg-white shadow">
              <div className="flex flex-col items-start justify-end gap-2 rounded-lg shadow">
                <div className="flex flex-col items-start justify-start self-stretch rounded-lg">
                  <div>
                    <Button
                      variant="text"
                      size="small"
                      sizeIcon="small"
                      colorIcon="danger"
                      startAdornment={<BinIcon className="mb-1 !text-secondary-red" />}
                      onClick={handleOpenDelete}
                      className="!h-8 !px-2 !py-0"
                      classNameTypography="!text-secondary-red !font-xs"
                      label={t('account_details.delete.title')}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="absolute bottom-[-3px] right-[12px] h-2 w-2 rotate-45 border-0 border-b-1 border-r-1 border-tertiary-400 bg-white"></div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
      <ModalDeleteAccount open={modalDeleteAccountOpen} onCancel={handleCloseDelete} />
    </>
  );
};

export default RemoveAccount;
